module.exports = __webpack_public_path__ + "media/assets/images/gmail/dressBagShoes-18cd8b716e008b3da75051ef007c54b1.gif";